export const view = {
  desktop: {
    land: {
      width: 1920,
      height: 1080,
    },
    port: {
      height: 1920,
      width: 1080,
    },
  },
  mobile: {
    land: {
      width: 960,
      height: 540,
    },
    port: {
      height: 960,
      width: 540,
    },
  },
}

export const scroll = {
  desktop: {
    land: 140,
    port: 510,
  },
  mobile: {
    land: 70,
    port: 255,
  },
}
